import { render, staticRenderFns } from "./server-faqs.vue?vue&type=template&id=0da9fdec&scoped=true"
import script from "./server-faqs.vue?vue&type=script&lang=ts"
export * from "./server-faqs.vue?vue&type=script&lang=ts"
import style0 from "./server-faqs.vue?vue&type=style&index=0&id=0da9fdec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da9fdec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HIcon: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/icons/h-icon.vue').default})
